import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  assetsUrl = environment.assetsWorkerUrl?? '';

  constructor() { }

  getImageUrl(url){
    url? url = this.assetsUrl+url : url = '';
  }

}
